import { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { FEATURE_LIST } from '../../../constants/subscription';

import FeatureProvider from '../../../components/FeatureProvider';
import WeatherForecast from '../../../components/weather-forecast';

import EmptyPlaceholder from '../../ui-components/EmptyPlaceholder';

function WeatherWidget() {
  const { list: farms } = useSelector(state => state.farm);

  const [state, setState] = useState({ weatherInfo: null });

  useEffect(() => {
    setFarmsData(farms);
  }, [farms]);

  function setFarmsData(farms) {
    if (!farms?.length) return;

    try {
      const [weatherFarm] = farms;
      const [coordinates] = weatherFarm?.master_geofence?.geo_json?.geometry?.coordinates[0] || [];
      const weatherInfo = weatherFarm && {
        headingTxt: `${weatherFarm.address.city}, ${weatherFarm.address.country}`,
        location: `${weatherFarm.address.city}, ${weatherFarm.address.country}`,
        latLng: {
          lat: coordinates[0],
          lng: coordinates[1]
        }
      };

      setState(prevState => ({ ...prevState, weatherInfo }));
    } catch {
      return;
    }
  }

  return (
    <FeatureProvider name={FEATURE_LIST.WEATHER_WIDGET}>
      {state.weatherInfo ? (
        <WeatherForecast
          apikey="a7d27f9bd8fad47e927c8936a8b7809b"
          headingTxt={state.weatherInfo.headingTxt || null}
          location={state.weatherInfo.location || null}
          latLng={state.weatherInfo.latLng || null}
        />
      ) : (
        <EmptyPlaceholder />
      )}
    </FeatureProvider>
  );
}

export default memo(WeatherWidget);
